<template lang="pug">
  div
    v-dialog(fullscreen :value='dialogOpen' transition='dialog-bottom-transition' @keydown.esc='preClose')

      v-container.px-0.pb-0(fluid grid-list-lg text-left :style="$vuetify.breakpoint.xsOnly ? 'padding-top: 44px;' : 'padding-top: 0;'")
        v-app-bar(dark color='primary' dense fixed)
          v-btn(icon dark @click='preClose')
            v-icon mdi-close
          v-toolbar-title(v-if='dialogOpen')
            | {{ pageTitle }}
          v-spacer
          v-btn.primary--text(color='white' :loading='saving' @click='saveWrapper()' :class="{'mr-4': $vuetify.breakpoint.smAndUp}")
            | {{ instance === 'editAudience' ? 'Save' : 'Add line' }}

        v-scroll-y-transition
          v-btn#toggle-map-btn.primary--text.mx-auto.mb-4(
            style='position: fixed; bottom:0; left: 0; right: 0; z-index: 2;'
            color='white'
            :width='!showMapOnly? 95 : 150'
            rounded
            @click='toggleView'
            v-if='$vuetify.breakpoint.xsOnly'
            elevation=12
          )
            v-icon.mr-2(color='primary') {{ showMapOnly? 'mdi-menu' : 'mdi-map-outline' }}
            | {{ showMapOnly? 'targeting' : 'map' }}

        v-row.ma-0(style='padding-top: 48px; background-color: #f8f9fa; min-height: 100vh;')
          v-fade-transition
            v-col.pa-0.pa-sm-3(
              cols=12 md=6 lg=5 xl=5
              style='min-height: calc(100vh - 48px);'
              v-if='showPage'
              v-show='!showMapOnly || $vuetify.breakpoint.smAndUp'
            )
              v-expansion-panels(multiple v-model='panelsStateController')
                panel-audience#audience-panel(
                  @updateForecast='updateForecast'
                  :parent='instance'
                  :parentLoading='!showPage'
                  :downloadingInventory='downloadingInventory'
                  :tab='audiencePanelTab'
                  @switchTab='switchPanelAudienceTab'
                  @inventoryListChanged='updateTableToMapSync'
                  @downloadInventory='downloadInventory')

          v-col.ma-0.pa-0(cols=12 md=6 lg=7 xl=7 order='first' order-md='last' v-if='showPage')
            div.sticky-column
              InventoryMap(
                v-if='mapExists'
                v-show='showMapOnly || $vuetify.breakpoint.smAndUp'
                :bound-initial-forecast='componentConfig.campaigns.boundInitialForecastCall'
                :compact-popups='$vuetify.breakpoint.xsOnly'
                :default-latitude='marketDefaultValues.mapCenter[1]'
                :default-longitude='marketDefaultValues.mapCenter[0]'
                :default-zoom='marketDefaultValues.mapZoom'
                :filter-on-move='filterOnMove'
                :forecast-inventory='forecastInventory'
                :forecast-inventory-loading='isForecastInventoryLoading'
                :forecast-loading='forecastLoading'
                :geo-targets='geoTargets'
                :get-venue-details-func='getVenueDetails'
                :height='mapHeight'
                :highlighted-geo-target='highlightedGeoTargetForMap'
                :impressions='{ total: totalImpressions, targeted: null }'
                :map-box-token='mapboxToken'
                :mapId='mapId'
                ref='mapComponent'
                :show-details-button='$vuetify.breakpoint.smAndUp'
                :show-fullscreen-button='$vuetify.breakpoint.smAndUp'
                :show-impressions='$vuetify.breakpoint.smAndUp'
                :show-inventory-summary='$vuetify.breakpoint.smAndUp'
                show-venue-popup
                :targeted-screens='targetedScreens'
                :targeted-venues='targetedVenues'
                :unit='marketDefaultValues.distanceUnit'
                :zoom-on-updated-forecast='pagination.filtering'
                :disable-recentering='disableRecentering'
                :resolve-geo-json-func='resolveGeoJson'
                @filterOnMoveChecked='filterOnMoveChecked'
                @mapBoundsUpdated='mapBoundsUpdated'
                @hideDetails='hideDetails'
                @seeDetails='seeDetails'
                @geoTargetSelected='geoTargetSelected'
                @geoTargetUnselected='geoTargetUnselected'
                @geoTargetAdded='geoTargetAdded'
                @geoTargetUpdated='geoTargetUpdated'
                @geoTargetRemoved='geoTargetRemoved'
              )
                template(v-slot:fullscreen-drawer-content='')
                  forecast-inventory(
                    :loading='isForecastVenuesLoading'
                    :downloading-inventory='downloadingInventory'
                    :items='forecastVenues'
                    :total-items='targetedVenues'
                    :has-more-items='pagination.hasMorePages'
                    :page='pagination.page'
                    :update-venue-inclusion-enabled='true'
                    @updateVenueInclusion='updateVenueInclusion'
                    @inventoryListChanged='updateTableToMapSync'
                    @downloadInventory='downloadInventory'
                  )

            forecastSummary(
              v-if="$vuetify.breakpoint.xsOnly"
              parent='editDialog'
              :showImpressions='true')

      v-dialog(v-model='isConfirmationOpen' maxWidth=380)
        v-card
          v-card-title Discard unsaved changes?
          v-card-actions
            v-spacer
            v-btn(text @click='isConfirmationOpen=false') Cancel
            v-btn(text @click='saveWrapper' :loading='saving') save
            v-btn(text color='primary' @click='discard') discard

</template>
<script>
import panelAudience from '@/components/panels/panelAudience.vue'

import { InventoryMap } from '@ayudasystems/campaign-targeting'
import forecastInventory from '@/components/forecast.inventory.vue'
import forecastSummary from '@/components/forecast.summary.vue'

import _ from 'lodash'

import audienceApi from '@/services/audience.api'
import venuesAPI from '@/services/venues.api'
import csvService from '@/services/csv.service'
import geoService from '@/services/geo.service'
import componentConfigService from '@/services/componentConfig'

import campsiteConfig from '@/config/campsite.config'
import geoBoundingBoxService from '@/services/geo.boundingbox.service'

export default {
  components: {
    InventoryMap,
    forecastInventory,
    forecastSummary,
    panelAudience
  },
  props: ['audience', 'dialogOpen'],
  created () {
    this.geoTargetsWithGeoJson = this.selectedGeoTargets
  },
  data () {
    return {
      showPage: false,
      saving: false,

      panelsStateController: [0],

      forecastOptionsLastVersion: null,

      isConfirmationOpen: false,
      confirmationFlag: null,

      audiencePanelTab: 0,
      showMapOnly: false,
      mapExists: true,
      downloadingInventory: false,

      mapboxToken: process.env.VUE_APP_MAPBOX_TOKEN,
      isFilterOnMoveVisible: false,
      disableRecentering: false,
      updateGeoTargetsJsonCT: null,
      geoTargetsWithGeoJson: [],
      highlightedGeoTargetForMap: null,
      geoTargetUpdatedFromMap: false
    }
  },

  computed: {
    exchanges () {
      return this.$store.getters['general/getExchanges']
    },
    exchange () {
      return this.$store.getters['createCampaign/getExchange']
    },
    isForecastInventoryLoading () {
      return this.$store.getters['audience/forecastInventoryLoading']
    },
    forecastInventory () {
      return this.$store.getters['audience/forecastInventory']
    },
    selectedGeoTargets () {
      return this.$store.getters['audience/selectedGeoTargets']
    },
    pageTitle () {
      return this.instance === 'editAudience'
        ? this.audience.name
        : this.$store.getters['createCampaign/getLineName']
    },

    forecast () {
      return this.$store.getters['audience/forecast']
    },
    forecastLoading () {
      return this.$store.getters['audience/forecastLoading']
    },
    targetedVenues () {
      return this.forecast.inventory.numberOfVenues
    },
    targetedScreens () {
      return this.forecast.inventory.numberOfScreens
    },
    totalImpressions () {
      return this.$store.getters['audience/forecast'].impressions.value
    },

    forecastVenues () {
      var forecastVenues = this.$store.getters['audience/forecastVenues']
      if (!forecastVenues) return []

      return forecastVenues.venues.map(venue => {
        const matchedGeoTarget = this.selectedGeoTargets.find(geoTarget => geoTarget.value === venue.id.toString())
        const isIncluded = !matchedGeoTarget || matchedGeoTarget.isIncluded
        return { ...venue, isIncluded }
      })
    },
    isForecastVenuesLoading () {
      return this.$store.getters['audience/forecastVenuesLoading']
    },

    pagination () {
      return this.$store.getters['audience/getPagination']
    },
    instance () {
      return this.audience ? 'editAudience' : 'createCampaign'
    },
    mapId () {
      return this.audience ? 'mapForEditAudience' : 'mapForAddAudience'
    },
    filterAsImove () {
      return this.$store.getters['audience/filterAsImove']
    },
    marketDefaultValues () {
      return this.$store.getters['general/marketDefaultValues']
    },
    mapHeight () {
      const offsetHeight = this.$vuetify.breakpoint.xsOnly
        ? campsiteConfig.barsHeight.appNavbar + campsiteConfig.barsHeight.forecastBar
        : campsiteConfig.barsHeight.appNavbar
      return 'calc(100vh - ' + offsetHeight + 'px)'
    },
    componentConfig () {
      return componentConfigService(this.$store.getters['user/isForAdServer'])
    },
    geoTargets () {
      return this.geoTargetsWithGeoJson
        .filter(geoTarget => geoTarget.type !== 'point_of_interest')
        .map(geoTarget => this.convertGeoTargetToMapFormat(geoTarget))
    },
    focusedGeoInfo () {
      return this.$store.getters['audience/getFocusedGeoInfo']
    },
    highlightedGeoTarget () {
      const focusedGeoTargetInfo = this.focusedGeoInfo
      return focusedGeoTargetInfo.index === -1 ? null : { geoTarget: this.selectedGeoTargets[focusedGeoTargetInfo.index], centerMap: focusedGeoTargetInfo.centerMap }
    },
    filterOnMove () {
      return {
        isVisible: this.isFilterOnMoveVisible,
        value: this.filterAsImove
      }
    },
    mapViewPort () {
      return this.$store.getters['audience/getMapViewPort']
    }
  },
  watch: {
    dialogOpen (newVal) {
      if (newVal) {
        this.forecastOptionsLastVersion = null

        // this.$store.commit('createCampaign/storeExchangeDetails', { exchange: this.exchanges[0] })
        const exchange = this.audience
          ? this.exchanges.find(e => e.id === this.audience.exchangeId)
          : this.exchanges[0]
        this.$store.commit('createCampaign/storeExchangeDetails', { exchange })

        // even if we make a "copy" of the Audience, the problem persists, i.e.
        // map underneath reads from same Store
        //   + upon Save, nothing to reload
        //   - when discarding changes, we'll have to reload OG Audience ..?
        // Proposals have their own store who handles all the preview Maps, so no problem there
        if (this.audience) {
          // should probably set Name according to "market defaults", like we did for Echange above
          this.$store.commit('createCampaign/setLineName', this.audience.name)
        } else {
          this.resetNewAudience()
        }

        this.$store.dispatch('general/getExchangesTargeting').then(() => {
          this.showPage = true
        })
      }
    },
    async selectedGeoTargets () {
      await this.updateTargetsGeoJson(this.geoTargetUpdatedFromMap)
      this.geoTargetUpdatedFromMap = false
    },
    highlightedGeoTarget: {
      immediate: true,
      async handler (newValue) {
        let geoTargetForMap = null
        let disableRecentering = true
        if (newValue?.geoTarget) {
          const geoTargetWithGeojson = await geoService.resolveGeoJsonForGeoTarget(newValue.geoTarget)
          geoTargetForMap = this.convertGeoTargetToMapFormat(geoTargetWithGeojson)
          disableRecentering = !newValue.centerMap
        }
        this.disableRecentering = disableRecentering
        this.highlightedGeoTargetForMap = geoTargetForMap
      }
    }
  },
  methods: {
    resetNewAudience () {
      this.$store.commit('audience/resetAudience')
      this.$store.commit('createCampaign/resetCreateCampaign')
    },

    getCommonForecastOptions () {
      const options = {
        mapId: this.mapId,
        exchange: this.exchange.key,
        buyerId: this.$store.getters['user/getOrganization'].id,
        startDate: this.$store.getters['createCampaign/getFullStartDate'],
        endDate: this.$store.getters['createCampaign/getFullEndDate'],
        targeting: this.$store.getters['audience/selectedTargets']
      }

      const geography = this.$store.getters['audience/geography']
      if (geography && Object.keys(geography).length > 0) {
        // do NOT send geoJSON(s) to Forecast for performance
        // easier to go through "selectedGeoTargets" and re-format
        // than trying to go through already formated "geography"
        var selectedGeoTargetsNoGeoJSON = geoService.removeGeoJSON(this.selectedGeoTargets)
        options.geography = geoService.geoTargetsToApiFormatting(selectedGeoTargetsNoGeoJSON)
      }

      const segments = this.$store.getters['audience/getEnvironmentsForecastApiFormat']
      if (segments.groups && segments.groups.length > 0) {
        options.segments = segments
      }
      return options
    },

    updateForecast (triggeredFromGeo = false) {
      if (triggeredFromGeo) return

      const currentForecastOptions = this.getCommonForecastOptions()
      const isTargetingEqual = this.forecastOptionsLastVersion
        ? _.isEqual(this.forecastOptionsLastVersion, currentForecastOptions)
        : false

      if (!isTargetingEqual) {
        // we do a check on "forecastOptionsLastVersion" to bypass inital loading
        // BUT, when re-opening the Dialog, updateForecast() is NOT called on load,
        // hence, if User changes targeting, we won't raise the "confirmationFlag"
        if (this.forecastOptionsLastVersion) {
          this.confirmationFlag = true
        }

        this.$store.dispatch('audience/updateForecast', { ...currentForecastOptions })
        this.forecastOptionsLastVersion = JSON.parse(JSON.stringify(currentForecastOptions))
      }

      // INVENTORY
      this.updateForecastInventory()

      // Venues
      if (this.audiencePanelTab === 1 && this.filterAsImove) {
        this.updateForecastVenues()
      }
    },

    updateForecastInventory () {
      this.$store.dispatch('audience/updateForecastInventory', this.getCommonForecastOptions())
    },

    updateForecastVenues () {
      this.$store.dispatch('audience/updateForecastVenues', this.getCommonForecastOptions())
    },

    isSameGeoTarget (geoTargetFromStore, geoTargetFromMap) {
      return geoTargetFromStore.value === geoTargetFromMap.geolocation.value &&
        geoTargetFromStore.label === geoTargetFromMap.geolocation.label &&
        geoTargetFromStore.radius === geoTargetFromMap.radius &&
        geoTargetFromStore.isIncluded === geoTargetFromMap.isIncluded
    },
    geoTargetSelected (geoTarget) {
      const index = this.selectedGeoTargets.findIndex(g => this.isSameGeoTarget(g, geoTarget))
      this.$store.commit('audience/setFocusedGeoInfo', { index: index, centerMap: false })
    },
    geoTargetUnselected () {
      this.$store.commit('audience/setFocusedGeoInfo', { index: -1, centerMap: false })
    },
    geoTargetAdded (geoTarget) {
      this.geoTargetUpdatedFromMap = true
      this.$store.dispatch('audience/updateGeoTargetsAction', [...this.selectedGeoTargets, this.convertGeoTargetToStoreFormat(geoTarget)])
      this.updateForecast()
    },
    geoTargetUpdated (updatedGeoTarget, mapIndex) {
      this.geoTargetUpdatedFromMap = true

      const initialUpdatedGeoTarget = this.geoTargets[mapIndex]
      const storeIndex = this.selectedGeoTargets.findIndex(g => this.isSameGeoTarget(g, initialUpdatedGeoTarget))

      const updatedGeoTargets = this.selectedGeoTargets
      updatedGeoTargets[storeIndex] = this.convertGeoTargetToStoreFormat(updatedGeoTarget)

      this.$store.dispatch('audience/updateGeoTargetsAction', updatedGeoTargets)
      this.updateForecast()
    },
    geoTargetRemoved (geoTarget) {
      this.geoTargetUpdatedFromMap = true

      const updatedGeoTargets = this.selectedGeoTargets.filter(g => !this.isSameGeoTarget(g, geoTarget))

      this.$store.dispatch('audience/updateGeoTargetsAction', updatedGeoTargets)
      this.updateForecast()
    },
    convertGeoTargetToStoreFormat (geoTarget) {
      return {
        label: geoTarget.geolocation.label,
        type: geoTarget.geolocation.type,
        value: geoTarget.geolocation.value,
        geography: {
          latitude: geoTarget.geolocation.geography.latitude,
          longitude: geoTarget.geolocation.geography.longitude,
          geoJSON: geoTarget.geolocation.geography.geoJSON
        },
        radius: geoTarget.radius,
        isIncluded: geoTarget.isIncluded
      }
    },
    convertGeoTargetToMapFormat (geoTarget) {
      return {
        isIncluded: geoTarget.isIncluded,
        radius: geoTarget.radius,
        isUnrendered: geoTarget.isOutsideOfViewPort,
        geolocation: {
          label: geoTarget.label,
          value: geoTarget.value,
          type: geoTarget.type,
          geography: {
            latitude: geoTarget.geography?.latitude,
            longitude: geoTarget.geography?.longitude,
            geoJSON: geoTarget.geography?.geoJSON
          }
        }
      }
    },

    async mapBoundsUpdated (mapApiPoco) {
      this.$store.commit('audience/setMapBounds', mapApiPoco)
      this.$store.commit('audience/setMapViewPort', mapApiPoco)

      await this.updateTargetsGeoJson(true)

      const pagination = {}
      if (this.filterAsImove) { pagination.page = 1 }
      if (this.pagination.filtering) { pagination.filtering = false }
      if (Object.keys(pagination).length) {
        this.$store.commit('audience/setPagination', pagination)
      }

      this.updateForecast()
    },

    switchPanelAudienceTab (tab) {
      this.isFilterOnMoveVisible = tab === 1
      this.audiencePanelTab = tab
      this.updateForecastVenues()
    },

    toggleView () {
      this.mapExists = false
      setTimeout(() => {
        this.mapExists = true
        this.showMapOnly = !this.showMapOnly
      }, 70)
    },

    hideDetails () {
      this.isFilterOnMoveVisible = false
    },
    seeDetails () {
      if (this.audiencePanelTab !== 1) {
        this.switchPanelAudienceTab(1)
      } else {
        this.isFilterOnMoveVisible = true
      }
    },
    filterOnMoveChecked (isChecked) {
      this.$store.commit('audience/setFilterAsImove', isChecked)
    },
    updateTableToMapSync (pagination) {
      this.$store.commit('audience/setPagination', pagination)
      this.updateForecastVenues()

      if (this.pagination.filtering && !this.$vuetify.breakpoint.xsOnly) {
        this.updateForecastInventory()
      }
    },
    updateVenueInclusion (venue) {
      this.$store.dispatch('audience/updateVenueInclusion', venue)
    },

    preClose () {
      const nameChanged = this.instance === 'editAudience' && this.audience.name !== this.$store.getters['createCampaign/getLineName']

      const currentForecastOptions = this.getCommonForecastOptions()
      const isTargetingEqual = this.forecastOptionsLastVersion
        ? _.isEqual(this.forecastOptionsLastVersion, currentForecastOptions)
        : false

      if (!isTargetingEqual) {
        this.confirmationFlag = true
      }

      if (!this.confirmationFlag && !nameChanged) this.close()
      else this.isConfirmationOpen = true
    },
    async discard () {
      if (this.audience) {
        await this.$store.dispatch('audience/loadAudience', this.audience)
        this.updateForecast()
      }
      this.close()
    },
    close (arg) {
      this.$emit('close', arg)
      this.confirmationFlag = null
      this.isConfirmationOpen = false
      this.mapExists = true
      this.showMapOnly = false
      this.showPage = false
    },

    saveWrapper () {
      this.instance === 'editAudience'
        ? this.saveAudience()
        : this.addAudience()
    },

    saveAudience () {
      this.saving = true

      const forecast = this.$store.getters['audience/forecast']

      const audience = {
        id: this.audience.id,
        name: this.$store.getters['createCampaign/getLineName'],
        exchangeId: this.exchange.id,
        organizationId: this.$store.getters['user/getOrganization'].id,
        audienceSegments: this.$store.getters['audience/selectedTargets'],
        numberOfFaces: forecast.inventory.numberOfScreens,
        numberOfVenues: forecast.inventory.numberOfVenues,
        reachAvailability: forecast.impressions.value,
        startDate: this.$store.getters['audience/getFullStartDate'],
        endDate: this.$store.getters['audience/getFullEndDate']
      }

      const geography = this.$store.getters['audience/geography']
      if (geography && Object.keys(geography).length > 0) {
        audience.geography = geography
      }

      const segments = this.$store.getters['audience/getEnvironmentsApiFormat']
      if (segments && Object.keys(segments).length > 0) {
        audience.segments = segments
      } else {
        audience.segments = {}
      }

      this.$store.dispatch('audience/editAudience', audience)
        .then(resp => {
          if (resp.status === 200) {
            resp.data.geography = geography
            resp.data.segments = segments

            this.$store.commit('snackbar/setSnackbar', {
              type: 'success',
              msg: `Audience ${audience.name} has been updated`
            })

            this.close(true)
          }
        })
        .catch(error => {
          let msg = error.response.data.errors[0]
          if (msg.errorCode === 'unexpected') {
            msg = 'Unexpected: ' + msg.id
          } else msg = msg.message

          this.$store.commit('snackbar/setSnackbar', {
            type: 'error',
            msg: `${msg}`
          })
        })
        .finally(() => {
          this.saving = false
        })
    },

    addAudience () {
      this.saving = true

      this.$store.dispatch('createCampaign/createCampaign')
        .then(id => {
          if (id) {
            const message = `Line order ${this.$store.getters['createCampaign/getLineName']} has been created`
            this.$store.commit('snackbar/setSnackbar', {
              type: 'success',
              msg: message
            })
            this.close(true)
          }
        })
        .catch(error => {
          this.$store.commit('snackbar/setSnackbar', {
            type: 'error',
            msg: `${error}`
          })
        })
        .finally(() => {
          this.saving = false
        })
    },

    downloadInventory (scope) {
      this.downloadingInventory = true

      const options = this.getCommonForecastOptions()
      audienceApi.getListTargetedInventory(options, scope)
        .then(res => {
          const name = this.$store.getters['createCampaign/getLineName'] || 'audience-inventory'
          csvService.validateAndExportCsv(res, name)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.downloadingInventory = false
        })
    },

    getVenueDetails (venueId) {
      return venuesAPI.getVenueDetails(venueId)
    },
    async updateTargetsGeoJson (disableRecentering = false) {
      if (this.updateGeoTargetsJsonCT) {
        this.updateGeoTargetsJsonCT.cancel('Request canceled by a newer request.')
        this.updateGeoTargetsJsonCT = null
      }

      const { getUpdatedGeoTargets, cancelTokenSource } = geoBoundingBoxService.getGeoTargetsJsonUpdater(this.selectedGeoTargets, this.mapViewPort, disableRecentering)
      if (!getUpdatedGeoTargets) return

      this.updateGeoTargetsJsonCT = cancelTokenSource
      try {
        this.geoTargetsWithGeoJson = await getUpdatedGeoTargets()
        this.disableRecentering = disableRecentering
      } catch (e) {} finally {
        this.updateGeoTargetsJsonCT = null
      }
    },
    async resolveGeoJson (geographyId, geoJSONFileUrl) {
      return await geoService.resolveGeoJson(geographyId, geoJSONFileUrl)
    }
  }
}
</script>

<style scoped lang="stylus">
.paddingXless >>> .v-expansion-panel-content__wrap
  padding-left: 0px
  padding-right: 0px
</style>
